import CellDate from '@/components/GokuDataGrid/CellDate'
import dayjs from 'dayjs'
import { Typogaphy } from 'vnetwork-ui'
import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { documentLevelMap, documentTypeMap } from '../../constant'
import { Documents } from '../../types/reponse'
import { TFunction } from 'i18next'

export const documentListColumn = (
    t: TFunction,
    onClickID: (row: Documents) => void
): GridColDefVNW<Documents>[] => [
    {
        field: 'id',
        headerName: 'ID',
        width: 30,
        renderCell: ({ row }) => (
            <Typogaphy
                className="text-primary hover:underline cursor-pointer"
                onClick={() => onClickID(row)}
            >
                {row?.document_id}
            </Typogaphy>
        ),
    },
    {
        field: 'document_id_reponse',
        headerName: 'document_id_reponse',
        width: 300,
        renderCell: ({ row }) => (
            <Typogaphy size="small">{row?.document_id_reponse}</Typogaphy>
        ),
    },
    {
        field: 'name_file',
        headerName: 'document_name',
        width: 200,
        renderCell: ({ row }) => (
            <Typogaphy size="small">{row?.name_file}</Typogaphy>
        ),
    },
    {
        field: 'description',
        headerName: 'description',
        width: 120,
        renderCell: ({ row }) => (
            <Typogaphy size="small">{row?.descriptions}</Typogaphy>
        ),
    },
    {
        field: 'start_day',
        headerName: 'start_day',
        width: 150,
        renderCell: ({ row }) => (
            <Typogaphy size="small">
                {dayjs(row?.start_day).format('DD/MM/YYYY')}
            </Typogaphy>
        ),
    },
    {
        field: 'end_day',
        headerName: 'end_day',
        width: 150,
        renderCell: ({ row }) => <CellDate date={row?.end_day} />,
    },
    {
        field: 'employee_name',
        headerName: 'document_owner',
        width: 150,
        renderCell: ({ row }) => (
            <Typogaphy size="small">{row?.employee_name}</Typogaphy>
        ),
    },
    {
        field: 'document_type',
        width: 150,
        headerName: 'document_type',
        renderCell: ({ row }) => (
            <Typogaphy size="small">
                {documentTypeMap(t, row?.document_type)}
            </Typogaphy>
        ),
    },
    {
        field: 'importance_level',
        width: 150,
        headerName: 'importance_level',
        renderCell: ({ row }) => (
            <Typogaphy size="small">
                {documentLevelMap(t, row?.document_level)}
            </Typogaphy>
        ),
    },
    {
        field: 'created_at',
        headerName: 'created_at',
        width: 120,
        renderCell: ({ row }) => (
            <Typogaphy size="small">
                {dayjs(row?.created_at).format('DD/MM/YYYY')}
            </Typogaphy>
        ),
    },
]
